<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0" v-if="loading">
    <v-row class="text-white bg-yellow-darken-3 pa-3 mt-0">
      <router-link to="/privacy">
        <v-icon color="white" icon="mdi-less-than" size="x-large" class="pr-5 pl-5"></v-icon>
      </router-link>
      <v-icon color="white" icon="mdi-pencil" size="x-large" class="pr-5 pl-5"></v-icon>
      <h3 class="pt-1">{{ consent.strings.CONSENT_LINK }}</h3>
    </v-row>
    <v-row v-if="!formSubmit && !consent.error.hasOwnProperty('fatal') && formDetails.currentid && formDetails.app">
      <!-- Check for IOS platform -->
      <v-col offset-lg="2" lg="8" offset="1" cols="10"
             v-if="consent.consent_error.hasOwnProperty('platform') && consent.consent_error.platform === 'ios'">
        <p>{{ consent.ios_string }}</p>
      </v-col>
      <!-- All other platforms -->
      <v-col offset-lg="2" lg="8" offset="1" cols="10" v-else>
        <!-- App logo and title -->
        <div class="app-info mt-5 mb-5">
          <v-img
              :src="'https://cdn.pikpok.com/pikpokgames.com/moregames/images/v3/'
              + formDetails.app.toLowerCase() + '/' + formDetails.app.toLowerCase() + '_icon.png'"
              class="app-logo">
            <template v-slot:error>
              <v-img src="../assets/imageNotFound.png"></v-img>
            </template>
          </v-img>
          <h3>{{ consent.strings.CONSENT_SETTINGS }} [{{ formDetails.app_title }}] </h3>
        </div>
        <!-- Form -->
        <v-form ref="form" lazy-validation>
          <!-- Pcubed ID -->
          <v-text-field
              v-model="formDetails.currentid"
              :label=consent.strings.PRIVACY_PP_ID
              :placeholder=consent.strings.PRIVACY_PP_ID_HINT
              required variant="solo-filled" readonly
          ></v-text-field>
          <!-- If no consent attach to user -->
          <v-row
              v-if="consent.consent_error.hasOwnProperty('error')
              && consent.consent_error.error === 'noconsent'">
            <v-col>{{ consent.strings.CONSENT_NOT_ACTIVE }}</v-col>
          </v-row>
          <!-- Render consent choices -->
          <v-row v-else class="ma-2">
            <v-text-field v-model="formDetails.app_id" v-show="false"></v-text-field>
            <v-row v-for="user_consent in consent.user_consents" :key="user_consent" align="center">
              <!-- If render_style Tick -->
              <v-col cols="12" md="5" class="order-last order-md-first"
                     v-if="user_consent.hasOwnProperty('render_style') && user_consent.render_style === 'tick'">
                <!-- if consent schema inverted=true -->
                <v-checkbox
                    v-if="user_consent.hasOwnProperty('inverted') && user_consent.inverted"
                    v-model="user_consent.user.action"
                    :label="consent.strings.CONSENT_STATE_DO_NOT_SELL"
                    true-value="rejected" hide-details
                    false-value="opt_in">
                </v-checkbox>
                <!-- else -->
                <v-checkbox
                    v-else
                    v-model="user_consent.user.action"
                    :label="consent.strings.CONSENT_STATE_DO_NOT_SELL"
                    true-value="opt_in" hide-details
                    false-value="rejected">
                </v-checkbox>
              </v-col>
              <!-- If render_style not set or option -->
              <v-col cols="12" md="4" v-else class="order-last order-md-first">
                <h4>{{ consent.strings.CONSENT_STATE_OPT_IN }}</h4>
                <v-radio-group inline v-model="user_consent.user.action" hide-details>
                  <v-radio
                      :label="consent.strings.CONSENT_ACTION_YES"
                      value="opt_in"></v-radio>
                  <v-radio
                      :label="consent.strings.CONSENT_ACTION_NO"
                      value="rejected"></v-radio>
                </v-radio-group>
              </v-col>
              <!-- Consent description -->
              <v-col cols="12" md="7">
                {{ user_consent.consent_description }}
              </v-col>
            </v-row>
            <!-- Captcha -->
            <v-col cols="12" class="pa-0">
              <v-row>
                <v-col cols="12" :style="captchaError ? 'color: red' : null ">
                  <h3>{{ consent.strings.PRIVACY_CAPTCHA }}</h3>
                </v-col>
                <v-col sm="7" md="6" class="captcha ml-2">
                  <template v-for="(char, index) in captchaChars" :key="index">
                  <span class="captcha-char"
                        :style="{ fontSize: char.fontSize + 'px', transform: 'rotate(' + char.rotation + 'deg)' }">
                    {{ char.char }}
                  </span>
                  </template>
                </v-col>
                <v-col sm="4">
                  <v-icon icon="mdi-refresh" size="x-large" class="pr-5 pl-5"
                          @click="generateUUIDCaptcha">
                  </v-icon>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      v-model="captcha"
                      :label=consent.strings.BUG_ANSWER
                      :placeholder=consent.strings.BUG_ANSWER
                      :rules="[v => !!v]"
                      required variant="solo-filled">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <!-- Hidden fields -->
            <v-text-field v-model="formDetails.hash_type" v-show="false"></v-text-field>
            <v-text-field v-model="formDetails.hash_value" v-show="false"></v-text-field>

            <v-btn
                color="yellow-darken-3"
                class="mt-4 mb-5 text-white"
                block @click="submit()">
              {{ consent.strings.BUG_SUBMIT }}
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <!-- Consent choice submit successfully -->
    <v-row
        v-else-if="formSubmit && !consent.error.hasOwnProperty('fatal')
        && !consent.consent_error.hasOwnProperty('error')" class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p>{{ consent.strings.CONSENT_THANKS }}</p>
      </v-col>
    </v-row>
    <!-- Error response after submit -->
    <v-row
        v-else-if="consent.error.hasOwnProperty('fatal')
        && consent.error['fatal'] === 1
        && !consent.consent_error.hasOwnProperty('error')" class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p>{{ consent.strings.CONSENT_ERROR }}</p>
      </v-col>
    </v-row>

    <v-row
        v-else-if="(consent.error.hasOwnProperty('fatal') && consent.error['fatal'] === 'notfound')
        || !formDetails.currentid || !formDetails.app" class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p>{{ consent.strings.CONSENT_NO_USER_FOUND }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "ConsentForm",
  components: {},
  data() {
    return {
      loading: false,
      formDetails: {},
      formSubmit: false,
      captcha: null,
      captchaChars: null,
      captchaError: false
    }
  },
  computed: {
    ...
        mapState({
          consent: state => state.supportStore.consent,
        }),
  },
  mounted() {
    this.getConsent({
      params: {
        ...this.$route.query
      }
    }).then(() => {
      this.loading = true
      this.formDetails = JSON.parse(JSON.stringify(this.consent.form_details))
      if (this.$route.query['hashedid']) this.formDetails['hash_value'] = this.$route.query['hashedid']
      if (this.$route.query['type']) this.formDetails['hash_type'] = this.$route.query['type']
    })
    this.generateUUIDCaptcha()
  },
  methods: {
    generateUUIDCaptcha() {
      let characters = '123456789'
      let chars = characters.split('')
      let captchaChars = []
      for (let i = 0; i < 6; i++) {
        let char = chars[Math.floor(Math.random() * chars.length)]
        let fontSize = Math.floor(Math.random() * 10) + 30 // random font size
        let rotation = Math.floor(Math.random() * 21) - 20 // random rotation
        captchaChars.push({char, fontSize, rotation})
      }
      this.captchaChars = captchaChars
    },

    async submit() {
      this.captcha !== this.captchaChars.map(c => c.char).join('') ? this.captchaError = true : this.captchaError = false
      const {valid} = await this.$refs.form.validate()
      if (valid && !this.captchaError) {
        let consentChoice = this.consent.user_consents.map(userConsent => {
          return {
            'consent_id': userConsent.user.consent_id, 'action': userConsent.user.action
          }
        })

        this.postConsent({
          data: {
            ...this.formDetails,
            consentChoice: JSON.stringify(consentChoice)
          }
        }).then(() => {
          this.formSubmit = true
        })
      }
    },

    ...mapActions([
      'getConsent',
      'postConsent'
    ])
  }
}
</script>

<style lang="scss" scoped>
.captcha {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: #f0f0f0;
  cursor: pointer;
}

.captcha-text {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  text-align: center;
  transform: rotate(-10deg);
  transform-origin: center;
}

.app-info {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  grid-gap: 30px;
}

@media only screen and (max-width: 500px) and (min-width: 340px) {
  .app-info {
    grid-template-columns: 100px 1fr;
    grid-gap: 10px;
  }
  .app-logo {
    width: 100px
  }
}

@media only screen and (max-width: 340px) {
  .app-info {
    grid-template-columns: 70px auto;
    grid-gap: 10px;
  }
  .app-logo {
    width: 70px
  }
}
</style>
